import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Slider = ({ settings, labels, emojis = {}, value, onChange, color, disabled }) => {

  const val = value || settings.initialValue;
  const [ emojiPosition, setEmojiPosition ] = useState(calculateEmojiPosition(val));
  const [ currentEmoji, setCurrentEmoji ] = useState(emojis[val] || null);
  const [ t, setT ] = useState(null);

  function calculateEmojiPosition(newValue) {
    return (parseInt(newValue, 10) - settings.min) / (settings.max - settings.min);
  }

  const onSliderEvent = event => {
    if(event.type === 'input') {
      setCurrentEmoji(emojis[event.target.value]);
      setEmojiPosition(calculateEmojiPosition(event.target.value));
    }

    clearTimeout(t);

    setT(setTimeout(() => {
      setCurrentEmoji(emojis[event.target.value]);
      setEmojiPosition(calculateEmojiPosition(event.target.value));
      onChange(event);
    }, 1000));
  }

  // 30px = width of the slider handle in css
  return (
    <Wrapper className={`${Object.keys(emojis).length ? 'hasEmoji' : ''} ${disabled ? 'disabled' : ''}`}>
      {currentEmoji ? <Emoji style={{left: `calc(${emojiPosition} * (100% - 30px))`}}>{currentEmoji}</Emoji> : null}
      <Input type="range" min={settings.min} max={settings.max} step={settings.step} defaultValue={val} onChange={onSliderEvent} onInput={onSliderEvent} disabled={disabled} />
      <Labels>
        <div>{labels.min}</div>
        {labels.med ? <div>{labels.med}</div> : null}
        <div>{labels.max}</div>
      </Labels>
    </Wrapper>
  );
};

Slider.propTypes = {
  settings: PropTypes.object,
  labels: PropTypes.object,
  emojis: PropTypes.object,
  value: PropTypes.number,
  onChange: PropTypes.func,
  color: PropTypes.string,
  disabled: PropTypes.bool,
};

const Wrapper = styled.div`
  position: relative;

  &.hasEmoji {
    padding-top: 35px;
  }
`;

const Emoji = styled.div`
  align-items: center;
  display: flex;
  font-size: 25px;
  height: 30px;
  justify-content: center;
  left: 0;
  line-height: 1;
  position: absolute;
  top: 0;
  width: 30px;
`;

const handle = `
  background: #fff;
  border: 3px solid;
  border-radius: 100%;
  box-sizing: border-box;
  height: 30px;
  width: 30px;
`;

const track = `
  background-color: #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  height: 6px;
`;

const Input = styled.input`
  appearance: none;
  margin: 8.5px 0;
  width: 100%;

  &::-moz-range-thumb {
    ${handle}
  }

  &::-webkit-slider-thumb {
    appearance: none;
    margin-top: -12px;
    ${handle}
  }

  &::-ms-thumb {
    margin-top: 0;
    ${handle}
  }

  &::-webkit-slider-runnable-track { ${track} }
  &::-moz-range-track { ${track} }
  &::-ms-track { ${track} }
`;

const Labels = styled.div`
  display: flex;
  font-size: 15px;
  justify-content: space-between;
  margin-top: 10px;
`;

export default Slider;
